/* eslint-disable tss-unused-classes/unused-classes */
import { makeStyles } from 'tss-react/mui'

export const useTableStyles = makeStyles()(theme => ({
  tableHeader: {
    whiteSpace: 'pre-line',
  },
  tableHeaderMobile: {
    display: 'none',
  },
  tableContainer: {
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    paddingTop: theme.spacing(2),
  },
  tableContainerMobile: {
    /** mobile table does not need as much horizontal spacing as on desktop, just the top padding for aesthetic purposes */
    paddingTop: theme.spacing(2),
  },
  table: {
    overflowX: 'hidden',
    borderRadius: theme.spacing(2),
  },
  tableMobile: {
    '& th': {
      /** give as much width as possible by removing some of the default MUI padding in table header */
      paddingRight: 0,
    },
  },
  row: {
    '&.MuiTableRow-root': {
      td: {
        height: 58,
      },
    },
  },
  searchContainer: {
    borderBottom: `1px solid ${theme.palette.shades.shade03}`,
    paddingBottom: theme.spacing(2),
  },
  search: {
    border: 'none',
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: 0,
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.background.paper2,
      textAlign: 'center',
    },
  },
  accordion: {
    boxShadow: 'none',
    backgroundColor: 'inherit',
    padding: 0,
    margin: 0,
  },
  accordionSummary: {
    flexDirection: 'row-reverse',
    height: 48,
  },
  accordionDetailsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  divider: {
    borderColor: theme.palette.shades.shade03,
  },
  chargingSessionMobileTableBody: {
    // hides the spacer row of TableComplete that sticks out of the rounded border. Due to removed inner padding of rows
    '& tr:first-of-type': {
      display: 'none',
    },
  },
}))
